import React, { useContext } from "react";
import commonContext from "../../../context/common";

function LoanBankCharge() {
    const { utils, lead } = useContext(commonContext);
    return (
        <>
            <div className="container mx-auto px-0 md:px-5">
                <h2 className="openSans-Reg text-black my-3 md:my-6 text-3xl md:text-3xl lg:text-3xl xl:text-4xl px-4 md:px-0">
                    Bank Charges
                </h2>
                <div className="accord-wrap">
                    <div className="accord w-full overflow-hidden mb-3">
                        <input
                            className="absolute opacity-0"
                            id="bankCharge1"
                            type="radio"
                            name="bankChargesAccord"
                        />
                        <label
                            className="block p-4 leading-normal cursor-pointer accord-label openSans-SemiBold"
                            htmlFor="bankCharge1"
                        >
                            <span className="w-10/12 inline-block">
                                Charges (Including Govt Taxes & Levies)
                            </span>
                        </label>
                        <div className="accord-content accord-content-bg overflow-hidden leading-normal">
                            <div className=" accord-content-inner">
                                <div className="flex flex-wrap w-full">
                                    <div className="relative w-full">
                                        <ul className="flex flex-wrap justify-between flex-row lg:flex-row">
                                            <li className="mb-2 lg:mb-0">
                                                <label className="openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                                    Processing Fee Amount (Non
                                                    Refundable)
                                                </label>
                                                <p className="openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl">
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    <span>
                                                        {utils.currencyFormat(
                                                            lead.processingFees
                                                        )}
                                                    </span>
                                                </p>
                                            </li>
                                            <li className="mb-2 lg:mb-0">
                                                <label className="openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                                    Cheque/ECS Swapping Charge
                                                </label>
                                                <p className="openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl">
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    <span>550</span> per
                                                    instance
                                                </p>
                                            </li>
                                            <li className="mb-0 lg:mb-0">
                                                <label className="openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                                    Processing Fees
                                                </label>
                                                <p className="openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl">
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    <span>649</span> per
                                                    instance
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="accord w-full overflow-hidden mb-3">
                        <input
                            className="absolute opacity-0"
                            id="bankCharge2"
                            type="radio"
                            name="bankChargesAccord"
                        />
                        <label
                            className="block p-4 leading-normal cursor-pointer accord-label openSans-SemiBold text-base md:text-xl"
                            htmlFor="bankCharge2"
                        >
                            <span className="w-10/12 inline-block">
                                Foreclosure Charges *
                            </span>
                        </label>
                        <div className="accord-content accord-content-bg overflow-hidden leading-normal">
                            <div className=" accord-content-inner">
                                <div className="flex flex-wrap w-full">
                                    <div className="relative w-full">
                                        <ul className="list-disc pl-5">
                                            <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                                                No foreclosure allowed within 6
                                                months from date of availing the
                                                car loan 6% of Principal
                                                Outstanding for pre-closures
                                                within 1 year from 7th EMI
                                            </li>
                                            <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                                                5% of Principal Outstanding for
                                                pre-closures within 13-24 months
                                                from 1st
                                            </li>
                                            <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1">
                                                EMI 3% of Principal Outstanding
                                                for pre-closures post 24 months
                                                from 1st EMI
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="accord w-full overflow-hidden mb-3">
                        <input
                            className="absolute opacity-0"
                            id="bankCharge3"
                            type="radio"
                            name="bankChargesAccord"
                        />
                        <label
                            className="block p-4 leading-normal cursor-pointer accord-label openSans-SemiBold text-base md:text-xl"
                            htmlFor="bankCharge3"
                        >
                            <span className="w-10/12 inline-block">
                                Part-Payment Charges*
                            </span>
                        </label>
                        <div className="accord-content accord-content-bg overflow-hidden leading-normal">
                            <div className=" accord-content-inner">
                                <div className="flex flex-wrap w-full">
                                    <div className="relative w-full">
                                        <ul className="list-disc pl-5">
                                            <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                                                Part-payment is allowed subject
                                                to completion of 12 months
                                                (i.e., Post payment of 12 EMIs)
                                            </li>
                                            <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                                                Part payment will be allowed
                                                twice only during loan tenure
                                            </li>
                                            <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                                                Part payment is allowed only
                                                once a year
                                            </li>
                                            <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                                                At any point of time, part
                                                payment will not increase beyond
                                                25% of Principal Outstanding
                                            </li>
                                            <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                                                5% on the part payment amount in
                                                case part prepayment is within
                                                13- 24 months from 1st EMI
                                            </li>
                                            <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1">
                                                3% on the part payment amount in
                                                case part prepayment is post 24
                                                months from 1st EMI
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="accord w-full overflow-hidden mb-3">
                        <input
                            className="absolute opacity-0"
                            id="bankCharge4"
                            type="radio"
                            name="bankChargesAccord"
                        />
                        <label
                            className="block p-4 leading-normal cursor-pointer accord-label openSans-SemiBold text-base md:text-xl"
                            htmlFor="bankCharge4"
                        >
                            <span className="w-10/12 inline-block">
                                Loan Cancellation
                            </span>
                        </label>
                        <div className="accord-content accord-content-bg overflow-hidden leading-normal">
                            <div className=" accord-content-inner">
                                <div className="flex flex-wrap w-full">
                                    <div className="relative w-full">
                                        <p className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1">
                                            In the event of cancellation,
                                            interest charges will be borne by
                                            the customer. Processing Fee, Stamp
                                            Duty and RTO Charges (Used Car
                                            Purchase / Refinance / Rewards) are
                                            non- refundable charges and would
                                            not be waived/refunded in case loan
                                            cancellation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="accord w-full overflow-hidden mb-3">
                        <input
                            className="absolute opacity-0"
                            id="bankCharge5"
                            type="radio"
                            name="bankChargesAccord"
                        />
                        <label
                            className="block p-4 leading-normal cursor-pointer accord-label openSans-SemiBold text-base md:text-xl"
                            htmlFor="bankCharge5"
                        >
                            <span className="w-10/12 inline-block">
                                Loan Re-schedulement & Re-Booking Charges
                            </span>
                        </label>
                        <div className="accord-content accord-content-bg overflow-hidden leading-normal">
                            <div className=" accord-content-inner">
                                <div className="flex flex-wrap w-full">
                                    <div className="relative w-full">
                                        <p className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                                            <span className="WebRupee">
                                                Rs.
                                            </span>
                                            1000 will be charged. If changes are
                                            required on RC, refundable security
                                            deposits - non interest bearing of
                                            ₹5000 would be required. It will be
                                            the borrower’s responsibility to
                                            provide the transferred Registration
                                            Certificate copy to Bank.
                                        </p>
                                        <div className="relative w-full">
                                            <ul className="flex flex-wrap justify-between flex-row lg:flex-row">
                                                <li className="mb-2 lg:mb-0 w-full lg:w-4/12">
                                                    <label className="openSans-Reg text-sm md:text-base light-gray-1">
                                                        Stamp Duty and other
                                                        statutory charges
                                                    </label>
                                                    <p className="openSans-SemiBold text-black text-base md:text-xl">
                                                        As per Applicable Law
                                                    </p>
                                                </li>
                                                <li className="mb-2 lg:mb-0 w-full lg:w-4/12">
                                                    <label className="openSans-Reg text-sm md:text-base light-gray-1">
                                                        Overdue Interest
                                                    </label>
                                                    <p className="openSans-SemiBold text-black text-base md:text-xl">
                                                        2% per month on overdue
                                                        EMI
                                                    </p>
                                                </li>
                                                <li className="mb-0 lg:mb-0 w-full lg:w-4/12">
                                                    <label className="openSans-Reg text-sm md:text-base light-gray-1">
                                                        Taxes
                                                    </label>
                                                    <p className="openSans-SemiBold text-black text-base md:text-xl">
                                                        At actuals, applicable
                                                        presently or in future
                                                    </p>
                                                </li>
                                            </ul>
                                            <div className="bg-light-yellow text-grey-darkest openSans-Reg py-2 px-4 my-3 md:my-5 text-sm rounded inline-flex items-center">
                                                {/* <!-- <svg className="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg> -->  */}
                                                <svg
                                                    className="w-6 h-6 mr-2"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                                    ></path>
                                                </svg>
                                                <span>
                                                    All other charges,
                                                    commissions and fees shall
                                                    be applicable at the rate
                                                    mentioned in the Application
                                                    form/ Sanction Letter or as
                                                    stipulated by the Bank from
                                                    time to time and are
                                                    exclusive of Taxes and
                                                    statutory levies as
                                                    applicable.
                                                </span>
                                            </div>

                                            <ul className="flex flex-wrap justify-between flex-row lg:flex-row">
                                                <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                                                    <label className="openSans-Reg text-sm md:text-base light-gray-1">
                                                        Legal, Repossession &
                                                        Incidental charges
                                                    </label>
                                                    <p className="openSans-SemiBold text-black text-base md:text-xl">
                                                        At actuals
                                                    </p>
                                                </li>
                                                <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                                                    <label className="openSans-Reg text-sm md:text-base light-gray-1">
                                                        CIBIL Charges (only on
                                                        request)
                                                    </label>
                                                    <p className="openSans-SemiBold text-black text-base md:text-xl">
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        <span>50</span>
                                                    </p>
                                                </li>
                                                <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                                                    <label className="openSans-Reg text-sm md:text-base light-gray-1">
                                                        Collateral Charges*
                                                    </label>
                                                    <p className="openSans-SemiBold text-black text-base md:text-xl">
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        <span>
                                                            {
                                                                lead.collateralCharges
                                                            }
                                                        </span>{" "}
                                                        per case**
                                                    </p>
                                                </li>
                                                <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                                                    <label className="openSans-Reg text-sm md:text-base light-gray-1">
                                                        Duplicate No Due
                                                        Certificate/NOC
                                                    </label>
                                                    <p className="openSans-SemiBold text-black text-base md:text-xl">
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        <span>500</span> per
                                                        instance
                                                    </p>
                                                </li>
                                                <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                                                    <label className="openSans-Reg text-sm md:text-base light-gray-1">
                                                        Duplicate Amortisation
                                                        Schedule Charges
                                                    </label>
                                                    <p className="openSans-SemiBold text-black text-base md:text-xl">
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        <span>200</span> per
                                                        schedule
                                                    </p>
                                                </li>
                                                <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                                                    <label className="openSans-Reg text-sm md:text-base light-gray-1">
                                                        LPG/ CNG NOC / Other
                                                        Special NOC
                                                    </label>
                                                    <p className="openSans-SemiBold text-black text-base md:text-xl">
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        <span>500</span> per
                                                        instance
                                                    </p>
                                                </li>
                                                <li className="mb-3 md:mb-5 w-full lg:w-4/12">
                                                    <label className="openSans-Reg text-sm md:text-base light-gray-1">
                                                        Commercial / Personal
                                                        use NOC
                                                    </label>
                                                    <p className="openSans-SemiBold text-black text-base md:text-xl">
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        <span>2250</span> per
                                                        NOC
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="px-4 sm:px-0">
                    <div className="bg-light-yellow text-grey-darkest openSans-Reg py-2 px-4 my-3 md:my-5 text-sm rounded">
                        <p className="mb-3 md:mb-5">
                            * Foreclosure charges and part payment charges are
                            exclusive of Govt Taxes & Levies. Govt Taxes &
                            Levies and other Government levies, as applicable,
                            would be charged additionally.
                        </p>
                        <p>
                            ** Collateral Charges / PDD Collection Charges are
                            refundable in case of Loan Cancellation.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoanBankCharge;
